import { axiosAdminUserAccount } from '@/lib/axiosAdminUserAccount';

export const logout = async (): Promise<unknown> => {
  const resp = await axiosAdminUserAccount.post<unknown>('/api/v/1/user/logout');
  return resp.data;
};
